import { render, staticRenderFns } from "./wxdoctorlist.vue?vue&type=template&id=145f89d2&scoped=true&"
import script from "./wxdoctorlist.vue?vue&type=script&lang=js&"
export * from "./wxdoctorlist.vue?vue&type=script&lang=js&"
import style0 from "./wxdoctorlist.vue?vue&type=style&index=0&id=145f89d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f89d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145f89d2')) {
      api.createRecord('145f89d2', component.options)
    } else {
      api.reload('145f89d2', component.options)
    }
    module.hot.accept("./wxdoctorlist.vue?vue&type=template&id=145f89d2&scoped=true&", function () {
      api.rerender('145f89d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxdoctorlist.vue"
export default component.exports